import React from "react";
import { NavLink } from "react-router-dom";
const Menu = ({currentMenu}) => {
    const menuOnClick = () => {
        document.getElementById("menucheckbox").checked = false;
      }
    
      return(
        <nav role='navigation'>
              <div id="menuToggle">
                <input type="checkbox" id="menucheckbox" />
                <span></span>
                <span></span>
                <span></span>
                <ul id="menu">
                    {
                        currentMenu.length > 0 &&
                        currentMenu.map((item) => {
                            return <li onClick={menuOnClick} key={item.menu_id}><NavLink to={item.menu_link}>{item.menu_label}</NavLink></li>
                        })
                    }
                    <li><NavLink to="/profile">Profile</NavLink></li>
                </ul>
              </div>
            </nav>
    );
};

export default Menu;